export const getUserLoading = state => state.userAuthReducer.userLoading;
export const getUser = state => state.userAuthReducer.user;
export const getEmail = state => state.userAuthReducer.user.email;
export const getProvider = state => state.userAuthReducer.user.provider;
export const getAuthError = state => state.userAuthReducer.error;
export const getCookiePref = state => state.userAuthReducer.cookiePref;
